export default "/images/vendor/flag-icon-css/flags/1x1/ea.svg?3328e1660d877378c782d9274b0d7908";